import { render, staticRenderFns } from "./deleteApplyRoomDiscount.vue?vue&type=template&id=35b4340c&scoped=true"
import script from "./deleteApplyRoomDiscount.vue?vue&type=script&lang=js"
export * from "./deleteApplyRoomDiscount.vue?vue&type=script&lang=js"
import style0 from "./deleteApplyRoomDiscount.vue?vue&type=style&index=0&id=35b4340c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b4340c",
  null
  
)

export default component.exports